
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as envCFRH4QomCg2LpV_3X7sMaUASXpdM5_3PlBz11DfENdQMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/env.vue?macro=true";
import { default as spotGr3NIEdzBl4GJkfvk0XrT7exBHY1LKooXbh1lyU_UnYMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/spot.vue?macro=true";
import { default as swapgal7ulvs3xYLEWhkrPb3rwitnbyvLmk8VryeeXFKogsMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/swap.vue?macro=true";
import { default as indexvJJctJAtuqikKdmnWtW1dq0teZ7I__AnBygQ7hX9Bn8Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/index.vue?macro=true";
import { default as termsiYW__Ug6KUN953enNb2QJvdaUJ7_45zczcyj9M2Z1ST_8Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/terms.vue?macro=true";
import { default as guildsABrkavp_45R06VGTv5_sJn_6zDcgjuZU4ZqKa0RnXoqAEMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/guilds.vue?macro=true";
import { default as mobileEh8YN933GYCy7WPJYrMkn2bAUsvtFxHIGNZGucJCQIMMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/mobile.vue?macro=true";
import { default as pointsg9C_45Hl1eFn96B2t2wURejDo85SFN7_SvRbQgUmqr_EcMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/points.vue?macro=true";
import { default as vaultso2SxrAHSxD1RxB4oYWh2CqFghfQ3Ss10mLGFg_3rsDUMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/vaults.vue?macro=true";
import { default as futures2UHOsGTORmtotJucAw8fmbuKOwHnxg_45sdu6zWJCLWdAMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/futures.vue?macro=true";
import { default as locales_DKbFippWfFNJbuxFufeV1JC5LVOate5bPRBMANDai4Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/locales.vue?macro=true";
import { default as marketsCb26QiBYU4bX2EB5X5W_9SvRSfMXLwgMwmaR5OlKHvMMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/markets.vue?macro=true";
import { default as indexwnyCJz2fSUMp6IYiMvhPoZGQbqXmkmOvAqhZW_45OqjTgMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/index.vue?macro=true";
import { default as indexUxHA0ZwY3P6PI8clYF_ydBS3liukOOvkFHvpQZmfDV4Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/index.vue?macro=true";
import { default as order_45historypwPfdOg6oYmiwWz3fCRNq0IE0fwKw2DD4E2K82_uRX4Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/order-history.vue?macro=true";
import { default as trade_45historyqCxtIpZJ_BB47a7DeFVrrXut9_ttadwSvITDS_45vL5yQMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/trade-history.vue?macro=true";
import { default as spotd0PUBfpSJyuqo8A4wmgy0aGDjOZea1IEoSGIjnK_5GgMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot.vue?macro=true";
import { default as indexMqUhR3Eg8WfqHsMpWAEubFgP1_JCu1az3LUAnO6oBagMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/balances/index.vue?macro=true";
import { default as indexHR6RaXo3rCQz_45y9TWDhf5vzIAtXtoKcphMGEmMXgzFAMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/index.vue?macro=true";
import { default as order_45historyS0KqVCrHbDnJ8ccGCMhHG5lxWikvRvD84YdtQNoxjDsMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/order-history.vue?macro=true";
import { default as trade_45historyK1tSJ95xmOjW3WOGfalFCUsgd9I9tbNckkMpW9UeoOUMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/trade-history.vue?macro=true";
import { default as advanced_45ordersFUq3GtLgUbD5hg9tLCAh_45wyKsnnqCB0KJXnD8aR8PqcMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/advanced-orders.vue?macro=true";
import { default as futureschu9E9REeJI8zLPu9ypuOxD_45ctjbaQkAMRKBdWgqQQYMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures.vue?macro=true";
import { default as index4oSjy6fLtV47Jsgv4di8dulTHiU_45l3uDdIXUWrxxXDoMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz/index.vue?macro=true";
import { default as granterclqGVrHPPZ_huV7ZG6tpusaZeDLH6s7N1DkN_452GcBYAMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz/granter.vue?macro=true";
import { default as authzlRunLkZp4tbSfQpdM7SN0HOUjnE_GBcQRDRkrauHayQMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz.vue?macro=true";
import { default as indexdBrtHrSbhWIqlbTgwucqMDh_45wHgFhgZTswFLNUVqJ6AMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/index.vue?macro=true";
import { default as indexdQeBB4trmEgOMZoV1qgcvkRJu8A5v6txn6SxBAm57dgMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/positions/index.vue?macro=true";
import { default as spot_45griddx6CtQFJQ8sCBebN9ij72aSgd1OGXm_dUS0VtWCrracMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot-grid.vue?macro=true";
import { default as indexJLunB77yvMXK_e5ZeiouAgZt4dDDU_45P4EeZlPbDsCD0Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/subaccounts/index.vue?macro=true";
import { default as indexsBmaNkg88GEy30JowpOznM2G70eXUJoOBInaQjHwZOQMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/swap/index.vue?macro=true";
import { default as futures_45gridRMSyDuXTqdR_qTjw1_45HSjuknJonrMGSRUK5my_ZawMoMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures-grid.vue?macro=true";
import { default as indexTQDApPh9ZCIFsu0K2BlXIeNMlOkzVuFSptx8y402MgQMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/wallet/index.vue?macro=true";
import { default as indexOPJrTap6UJAMhR75WcB_hjmi_cp07URZgW8iLbdzwP8Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/funding-history/index.vue?macro=true";
import { default as portfolioY1h3QWEFHMv9FsdNP06_45a_LgUS0ytlPl9mXAx92he4AMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/portfolio.vue?macro=true";
import { default as _91ref_932Xl_jqsj33rc2It18hzNcDsDsVn0uhyXGeBUh2P5suUMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/ref/[ref].vue?macro=true";
import { default as indexti3YjBZVsX_w6Y9kt8qghzBJp0aSxmqsgCQ2jgAfLRMMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/ref/index.vue?macro=true";
import { default as index3xIZx2YQ0vnv1MrvzfZnj4eD7kp2_45ab8S1_S_dM43IUMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/index.vue?macro=true";
import { default as campaignXDgukUsm1lSWZGtmOUtyaWFzumw8bMH8S0m68NyBODYMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/campaign.vue?macro=true";
import { default as dashboardLpiUB0fhI3J_45PvtC5RalwrQSiOm_qfMi5jkel_45cAuWoMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/dashboard.vue?macro=true";
import { default as lp_45rewardsdap0kgiKsIijfa5_FE6_45_45uAFCc_2zQI3ONjSm3xG3_UMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards.vue?macro=true";
import { default as playgroundYIkGP66HsK68RxVhMaw_457WyMJqmOylpKY0MPXc7CqcAMeta } from "/home/runner/_work/injective-helix/injective-helix/node_modules/.c12/github_InjectiveLabs_injective_B5Ll5JMqHu/pages/playground.vue?macro=true";
import { default as indexsGkq20v74Alx5pUXKPHhyPxFFAdHTHOCq_bg06Ald_45sMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/index.vue?macro=true";
import { default as competitionr7A8ij4SDFJTUe2qlgXZ96TV00ChJfjRKrqlGDBnOUsMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/competition.vue?macro=true";
import { default as past_45competitionsye9PQOsOmmxh9inO_JRv1vd_fWTv2ae4cc8pH1_izRwMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/past-competitions.vue?macro=true";
import { default as leaderboardxyf66whlvEMym6XeeKKWGtaAncn_45rGLwLDArIQ9BetcMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/leaderboard.vue?macro=true";
import { default as maintenance00KIlK3THwxhQnUpd9vMSgkyBE6__45CmxxoEdyI_HDMEMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/maintenance.vue?macro=true";
import { default as fee_45discounts2twQyBB8F5C5zNkcSeY7qcYgVesUqOpbthJThUAzF0QMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/fee-discounts.vue?macro=true";
import { default as _91guild_93bv1lhDRVIFQi0C8TTDhRiHRJhUWjAj5k8u8Qg_8xWCoMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/guild/[guild].vue?macro=true";
import { default as institutionalM_I6q_451OsYDfiP96ugY4Vd1sbWD4wrLu6W0_WOKJVasMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/institutional.vue?macro=true";
import { default as privacy_45policyZFx1kulbuWJgI4IRci6V7NGcCtC_Rc4Md_2sHq_SGPQMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/privacy-policy.vue?macro=true";
import { default as trade_45and_45earnlqRdkXWVmK4GiGp81WKYLw7xdORcBc2KAb_6k9TKmcIMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/trade-and-earn.vue?macro=true";
import { default as indexy6HMZtJ42gyAG3uI3Yuu5zWUmsLt9XPXZ0c5wdOQV3IMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/trading-bots/index.vue?macro=true";
import { default as tesla_45competition_45termsVaD3J68CUKp0VXkxotvW4T2ruyz5l5Vo7n_45khkqlgIAMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/tesla-competition-terms.vue?macro=true";
import { default as like_45a_45g_45competition_45termsUlwO3kVkjYbIUvwlvy7fMH8KgY6KLcrj7j9i9TtTaHUMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/like-a-g-competition-terms.vue?macro=true";
import { default as competition_45privacy_45policy_45tesla4AQ0m2lLnV64gjjS_45UZX2WTYYAbKIRUXeSq0LJeeW5YMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-tesla.vue?macro=true";
import { default as competition_45privacy_45policy_45gwagonEmxnAEeuI_45ImH0QX1c9D3CBUSSGJqwHJNnpdqUNyhAwMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-gwagon.vue?macro=true";
import { default as own_45your_45assets_45competition_45termsfoW3a9dNDICagw42_45SBiMBqP0pr1iCexoNC3ddB31moMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/own-your-assets-competition-terms.vue?macro=true";
import { default as indexwkpKc1Vb0ls19OMtfHDE_45rVBu7HgrLks5c1wmBj32m0Meta } from "/home/runner/_work/injective-helix/injective-helix/pages/trading-bots/liquidity-bots/spot/index.vue?macro=true";
import { default as competition_45privacy_45policy_45own_45your_45assetspfpyOS9MlDo7Ki4h3MgcpN9hTqB_hktx0gZCQ2zND9kMeta } from "/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-own-your-assets.vue?macro=true";
export default [
  {
    name: "env",
    path: "/env",
    meta: envCFRH4QomCg2LpV_3X7sMaUASXpdM5_3PlBz11DfENdQMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/env.vue")
  },
  {
    name: "spot",
    path: "/spot",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/spot.vue")
  },
  {
    name: "swap",
    path: "/swap",
    meta: {"middleware":["swap"]},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/swap.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/terms.vue")
  },
  {
    name: "guilds",
    path: "/guilds",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/guilds.vue")
  },
  {
    name: "mobile",
    path: "/mobile",
    meta: mobileEh8YN933GYCy7WPJYrMkn2bAUsvtFxHIGNZGucJCQIMMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/mobile.vue")
  },
  {
    name: "points",
    path: "/points",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/points.vue")
  },
  {
    name: "vaults",
    path: "/vaults",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/vaults.vue")
  },
  {
    name: "futures",
    path: "/futures",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/futures.vue")
  },
  {
    name: "locales",
    path: "/locales",
    meta: locales_DKbFippWfFNJbuxFufeV1JC5LVOate5bPRBMANDai4Meta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/locales.vue")
  },
  {
    name: "markets",
    path: "/markets",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/markets.vue")
  },
  {
    name: portfolioY1h3QWEFHMv9FsdNP06_45a_LgUS0ytlPl9mXAx92he4AMeta?.name,
    path: "/portfolio",
    meta: {"middleware":["connected"]},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio.vue"),
    children: [
  {
    name: "portfolio",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/index.vue")
  },
  {
    name: spotd0PUBfpSJyuqo8A4wmgy0aGDjOZea1IEoSGIjnK_5GgMeta?.name,
    path: "orders/spot",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot.vue"),
    children: [
  {
    name: "portfolio-orders-spot",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/index.vue")
  },
  {
    name: "portfolio-orders-spot-order-history",
    path: "order-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/order-history.vue")
  },
  {
    name: "portfolio-orders-spot-trade-history",
    path: "trade-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot/trade-history.vue")
  }
]
  },
  {
    name: "portfolio-balances",
    path: "balances",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/balances/index.vue")
  },
  {
    name: futureschu9E9REeJI8zLPu9ypuOxD_45ctjbaQkAMRKBdWgqQQYMeta?.name,
    path: "orders/futures",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures.vue"),
    children: [
  {
    name: "portfolio-orders-futures",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/index.vue")
  },
  {
    name: "portfolio-orders-futures-order-history",
    path: "order-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/order-history.vue")
  },
  {
    name: "portfolio-orders-futures-trade-history",
    path: "trade-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/trade-history.vue")
  },
  {
    name: "portfolio-orders-futures-advanced-orders",
    path: "advanced-orders",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures/advanced-orders.vue")
  }
]
  },
  {
    name: authzlRunLkZp4tbSfQpdM7SN0HOUjnE_GBcQRDRkrauHayQMeta?.name,
    path: "settings/authz",
    meta: authzlRunLkZp4tbSfQpdM7SN0HOUjnE_GBcQRDRkrauHayQMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz.vue"),
    children: [
  {
    name: "portfolio-settings-authz",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz/index.vue")
  },
  {
    name: "portfolio-settings-authz-granter",
    path: "granter",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/authz/granter.vue")
  }
]
  },
  {
    name: "portfolio-settings",
    path: "settings",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/settings/index.vue")
  },
  {
    name: "portfolio-positions",
    path: "positions",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/positions/index.vue")
  },
  {
    name: "portfolio-orders-spot-grid",
    path: "orders/spot-grid",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/spot-grid.vue")
  },
  {
    name: "portfolio-subaccounts",
    path: "subaccounts",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/subaccounts/index.vue")
  },
  {
    name: "portfolio-history-swap",
    path: "history/swap",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/swap/index.vue")
  },
  {
    name: "portfolio-orders-futures-grid",
    path: "orders/futures-grid",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/orders/futures-grid.vue")
  },
  {
    name: "portfolio-history-wallet",
    path: "history/wallet",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/wallet/index.vue")
  },
  {
    name: "portfolio-history-funding-history",
    path: "history/funding-history",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/portfolio/history/funding-history/index.vue")
  }
]
  },
  {
    name: "ref-ref",
    path: "/ref/:ref()",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/ref/[ref].vue")
  },
  {
    name: "ref",
    path: "/ref",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/ref/index.vue")
  },
  {
    name: lp_45rewardsdap0kgiKsIijfa5_FE6_45_45uAFCc_2zQI3ONjSm3xG3_UMeta?.name,
    path: "/lp-rewards",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards.vue"),
    children: [
  {
    name: "lp-rewards",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/index.vue")
  },
  {
    name: "lp-rewards-campaign",
    path: "campaign",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/campaign.vue")
  },
  {
    name: "lp-rewards-dashboard",
    path: "dashboard",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/lp-rewards/dashboard.vue")
  }
]
  },
  {
    name: "playground",
    path: "/playground",
    meta: playgroundYIkGP66HsK68RxVhMaw_457WyMJqmOylpKY0MPXc7CqcAMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/node_modules/.c12/github_InjectiveLabs_injective_B5Ll5JMqHu/pages/playground.vue")
  },
  {
    name: leaderboardxyf66whlvEMym6XeeKKWGtaAncn_45rGLwLDArIQ9BetcMeta?.name,
    path: "/leaderboard",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/leaderboard.vue"),
    children: [
  {
    name: "leaderboard",
    path: "",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/index.vue")
  },
  {
    name: "leaderboard-competition",
    path: "competition",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/competition.vue")
  },
  {
    name: "leaderboard-past-competitions",
    path: "past-competitions",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/leaderboard/past-competitions.vue")
  }
]
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenance00KIlK3THwxhQnUpd9vMSgkyBE6__45CmxxoEdyI_HDMEMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/maintenance.vue")
  },
  {
    name: "fee-discounts",
    path: "/fee-discounts",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/fee-discounts.vue")
  },
  {
    name: "guild-guild",
    path: "/guild/:guild()",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/guild/[guild].vue")
  },
  {
    name: "institutional",
    path: "/institutional",
    meta: institutionalM_I6q_451OsYDfiP96ugY4Vd1sbWD4wrLu6W0_WOKJVasMeta || {},
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/institutional.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/privacy-policy.vue")
  },
  {
    name: "trade-and-earn",
    path: "/trade-and-earn",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/trade-and-earn.vue")
  },
  {
    name: "trading-bots",
    path: "/trading-bots",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/trading-bots/index.vue")
  },
  {
    name: "tesla-competition-terms",
    path: "/tesla-competition-terms",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/tesla-competition-terms.vue")
  },
  {
    name: "like-a-g-competition-terms",
    path: "/like-a-g-competition-terms",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/like-a-g-competition-terms.vue")
  },
  {
    name: "competition-privacy-policy-tesla",
    path: "/competition-privacy-policy-tesla",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-tesla.vue")
  },
  {
    name: "competition-privacy-policy-gwagon",
    path: "/competition-privacy-policy-gwagon",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-gwagon.vue")
  },
  {
    name: "own-your-assets-competition-terms",
    path: "/own-your-assets-competition-terms",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/own-your-assets-competition-terms.vue")
  },
  {
    name: "trading-bots-liquidity-bots-spot",
    path: "/trading-bots/liquidity-bots/spot",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/trading-bots/liquidity-bots/spot/index.vue")
  },
  {
    name: "competition-privacy-policy-own-your-assets",
    path: "/competition-privacy-policy-own-your-assets",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/competition-privacy-policy-own-your-assets.vue")
  },
  {
    name: "stocks",
    path: "/futures/stocks",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/futures.vue")
  },
  {
    name: "futures-slug",
    path: "/futures/:slug()",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/futures.vue")
  },
  {
    name: "spot-slug",
    path: "/spot/:slug()",
    component: () => import("/home/runner/_work/injective-helix/injective-helix/pages/spot.vue")
  }
]